import HighlightingPlugin from "./HighlightingPlugin";

export default HighlightingPlugin;
